const DeleteIcon = ({ w = "17", h = "19" }) => {
  return (<svg width={w} height={h} viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 18.5C2.95 18.5 2.47917 18.3042 2.0875 17.9125C1.69583 17.5208 1.5 17.05 1.5 16.5V3.5H0.5V1.5H5.5V0.5H11.5V1.5H16.5V3.5H15.5V16.5C15.5 17.05 15.3042 17.5208 14.9125 17.9125C14.5208 18.3042 14.05 18.5 13.5 18.5H3.5ZM13.5 3.5H3.5V16.5H13.5V3.5ZM5.5 14.5H7.5V5.5H5.5V14.5ZM9.5 14.5H11.5V5.5H9.5V14.5Z" fill="currentColor" />
  </svg>)
}
export default DeleteIcon;